import { render, staticRenderFns } from "./personalList.vue?vue&type=template&id=605200e2&scoped=true&"
import script from "./personalList.vue?vue&type=script&lang=js&"
export * from "./personalList.vue?vue&type=script&lang=js&"
import style0 from "./personalList.vue?vue&type=style&index=0&id=605200e2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605200e2",
  null
  
)

export default component.exports